// extracted by mini-css-extract-plugin
export default {"container":"AddAlertComponent_container__siqHb","header":"AddAlertComponent_header__NITvw","form":"AddAlertComponent_form__obqG6"};